import "./Address.scss";
import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import {
  AddressContext,
  AddressContextProps,
} from "../../../Contexts/AddressContext";

import { Header, Title, Subtitle, Subheader } from "../../../Components/Typography";
import { LogoSection } from "../../../Components/LogoSection";
import { OrderSummary } from "../../../Components/OrderSummary";

import BoxIcon from "../../../assets/box-icon.png";
import BoxIconActive from "../../../assets/box-icon-active.png";
import ShopIcon from "../../../assets/shop-icon.png";
import ShopIconActive from "../../../assets/shop-icon-active.png";
import { CardAddressType } from "../../../Components/Cards";
import { AddressFormPickup } from "./AddressFormPickup";
import { AddressFormSend } from "./AddressFormSend";
import useResponsive from "../../../hooks/useResponsive";
import AddressTypeEnum from "../../../types/AddressTypeEnum";
import { routes } from "../../../Router";
import { OrderContext, OrderContextProps } from "../../../Contexts/OrderContext";

export const Address = () => {
  const navigate = useNavigate();
  const { isDesktopOrLaptop } = useResponsive();
  const { addressType, addressSend, addressPickup, getBranches }: AddressContextProps =
    useContext<any>(AddressContext);
  const { getCalculatedShippingCost }: OrderContextProps =
    useContext<any>(OrderContext);
  const { selectedAddressType, setSelectedAddressType } = addressType;
  const isAddressTypeSend = selectedAddressType === AddressTypeEnum.SEND;
  const isAddressTypePickup = selectedAddressType === AddressTypeEnum.PICKUP;

  const onClickAddressType = (addressType: AddressTypeEnum) => {
    setSelectedAddressType(addressType);
    if (addressType === AddressTypeEnum.PICKUP) {
      getCalculatedShippingCost({postalCode: null})
    } else {
      getCalculatedShippingCost({postalCode: addressSend.addressSendForm.postalCode})
    }
  };

  const onClickNext = () => {
    if (
      (isAddressTypeSend && addressSend.validateAddressSendForm()) ||
      (isAddressTypePickup && addressPickup.selectedBranch)
    ) {
      navigate(routes.clientInfo.path);
    } else {
      // [Mobile] scroll to top 
      window.scrollTo(0, 0);
    }
  };

  const onClickBack = () => {
    navigate(routes.clientNewOrder.path);
  };

  useEffect(() => {
    getBranches()
  }, [])

  return (
    <div className={isDesktopOrLaptop ? "address-desktop" : "address-mobile"}>
      <LogoSection />

      <div className="main-column">
        <div className="top-content">
          <div className="next-steps-section">
            <div className="step"></div>

            <div className="step">
              <Subheader disabled>Paso 1</Subheader>
              <Subtitle disabled>Archivos y Opciones de Impresión</Subtitle>
            </div>
          </div>
          <div className="title-section">
            <Subheader>Paso 2</Subheader>

            <Title>Opciones de Envío</Title>
          </div>

          <div className="address-options-section">
            <CardAddressType
              imgIcon={BoxIcon}
              imgIconActive={BoxIconActive}
              onClick={() => onClickAddressType(AddressTypeEnum.SEND)}
              text="Envío a Domicilio"
              active={isAddressTypeSend}
            />
            <CardAddressType
              imgIcon={ShopIcon}
              imgIconActive={ShopIconActive}
              onClick={() => onClickAddressType(AddressTypeEnum.PICKUP)}
              text="Retiro por local"
              active={isAddressTypePickup}
            />
          </div>

          <div className="address-form-section">
            {isAddressTypeSend ? <AddressFormSend /> : <AddressFormPickup />}
          </div>
        </div>

        <div className="bottom-content">
          <div className="next-steps-section">
            <div className="step"></div>

            <div className="step">
              <Subheader disabled>Paso 3</Subheader>
              <Subtitle disabled>Datos de Pago</Subtitle>
            </div>

            <div className="step">
              <Subheader disabled>Paso 4</Subheader>
              <Subtitle disabled>Confirmar y pagar la orden</Subtitle>
            </div>
          </div>
        </div>
      </div>

      <OrderSummary
        isNextEnabled
        showAddressForm
        showPaymentForm={false}
        onClickNext={onClickNext}
        onClickBack={onClickBack}
      />
    </div>
  );
};
